import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService, STORAGE_KEYS } from './storage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const token = storage.getItem<string>(STORAGE_KEYS.LOGIN_TOKEN);
  if (token) {
    return true;
  }

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
